import { useCallback } from 'react'
import { UseFormSetValue } from 'react-hook-form'

import { PracticeLocation } from '@/core/types/dmp-connect'

import { useAppDispatch } from '@/redux/rootReducer'
import { setCpxCard, setTlsiConnector } from '@/redux/reducers/dmp-connect.reducer'

import { getBillingNumberFromPracticeLocation } from '../lib/getBillingNumberFromPracticeLocation'
import { TlsiConnectorFormData } from './useTlsiConnectorForm'

export function useTlsiConnectorActions(setValue: UseFormSetValue<TlsiConnectorFormData>) {
  const dispatch = useAppDispatch()

  const resetCard = useCallback(() => {
    dispatch(setCpxCard(null))
    dispatch(setTlsiConnector(null))
  }, [dispatch])

  const selectPracticeLocation = useCallback(
    (index: number, practiceLocation: PracticeLocation) => {
      setValue('practiceLocation', index)
      const billingNumber = getBillingNumberFromPracticeLocation(practiceLocation)
      setValue('billingNumber', billingNumber)
    },
    [setValue]
  )

  return {
    resetCard,
    selectPracticeLocation,
  }
}
